export function parseEventKey(key) {
    const parts = key.split('_');
    const courseIndex = parts.findIndex(p => p === '25m' || p === '50m');
    if (courseIndex <= 0 || courseIndex + 2 >= parts.length)
        return null;
    return {
        event: parts.slice(0, courseIndex).join(' '),
        course: parts[courseIndex],
        gender: parts[courseIndex + 1],
    };
}
